import styled from "styled-components";

export const Container = styled.div`
  height: 58px;
  background: #030096;
  padding: 8px 0 8px 16px;
  display: flex;
  align-items: center;

  @media screen and (max-width: 1024px) {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
